import Sticky from '../../../../Common/Sticky/Sticky'
import cx from 'classnames'
import styles from './FixedSection.css'

const FixedSection = (props = {}) => {
  return (
    <Sticky
      topOffset={10}
      disableCompensation
    >
      {({ style }) => (
        <div
          className={cx(styles.FixedSection, props.className)}
          style={style}
          data-role='fixed-section'
        >
          {props.children}
        </div>
      )}
    </Sticky>

  )
}

export default FixedSection
